import { filter, map } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AppRoutingPaths } from '@wo-mc/routing';
import { appContextFeature } from '@wo-mc/+state';

export const hasRequiredContextGuard: CanActivateFn = () => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(appContextFeature.selectHasRequiredContext).pipe(
    filter(hasRequiredContext => hasRequiredContext != null),
    map(hasRequiredContext => hasRequiredContext || router.createUrlTree([ AppRoutingPaths.APP_CONTEXT ], {
      queryParams: {
        redirect: window.location.href,
      },
    })),
  );
};
